import { useEffect, useState } from 'react';
import { api } from '../api';
import { toast } from 'sonner';
import { Users } from 'lucide-react';

export default function WorkersPage() {
  const [workers, setWorkers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/opsive/workers')
      .then(setWorkers)
      .catch(e => toast.error(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-bold text-gray-900">Workers</h1>
      {loading && <p className="text-sm text-gray-400">Loading…</p>}
      {!loading && workers.length === 0 && (
        <div className="text-center py-16 text-gray-400">
          <Users className="w-10 h-10 mx-auto mb-3 opacity-30" />
          <p className="text-sm">No workers registered yet. Workers sign up through SharpWithIt.vip.</p>
        </div>
      )}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {workers.map(w => (
          <div key={w.user_id} className="bg-white border border-gray-200 rounded-xl p-5">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold text-sm">
                {w.name?.[0]?.toUpperCase() || '?'}
              </div>
              <div>
                <p className="font-semibold text-gray-900 text-sm">{w.name}</p>
                <p className="text-xs text-gray-500">{w.email}</p>
              </div>
            </div>
            <div className="flex items-center justify-between text-xs text-gray-500">
              <span>Active jobs</span>
              <span className={`font-bold ${w.active_jobs > 0 ? 'text-blue-600' : 'text-gray-400'}`}>
                {w.active_jobs}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
